export const DEFERRED_REVENUE_EXPORT_COPY = {
  triggerLabel: 'Export to CSV',
  triggerAriaLabel:
    'Export deferred revenue schedule to CSV. A download link will be emailed to you.',
  modal: {
    title: 'Export Deferred Revenue Schedule CSV',
    body: "We'll send a download link to your email. This may take a few minutes.",
    submitLabel: 'Export',
    cancelLabel: 'Cancel'
  },
  notifications: {
    success:
      "We're generating your report. You'll receive an email when it's ready.",
    error: 'Failed to export deferred revenue schedule'
  },
  docs: {
    label: 'Learn more',
    href: 'https://docs.sequencehq.com/revenue-recognition/overview'
  }
} as const
